import type { Router } from 'vue-router'

import { useRegisterSW } from 'virtual:pwa-register/vue'

/**
 * Router guard for PWA version check and automatic update
 * @param router Vue Router instance
 */
export function createVersionGuard(router: Router) {
  const { needRefresh, updateServiceWorker } = useRegisterSW()
  const { showUpdateScreen, hideUpdateScreen } = useUpdateScreenStore()

  router.beforeEach(() => {
    // Check for updates before each route change
    if (needRefresh.value) {
      showUpdateScreen()
    }
  })

  // Version check on page transitions with afterEach hook
  router.afterEach(async () => {
    // Automatically update if there's a new version available
    if (needRefresh.value) {
      try {
        // Update PWA (activate new service worker)
        await updateServiceWorker(true)
        // Hide the update screen after updating
        hideUpdateScreen()
      } catch (error) {
        console.error('Error occurred during automatic update:', error)
      }
    }
  })
}

/**
 * Helper function to manually update the service worker and refresh the page
 */
export async function updateServiceWorkerManually() {
  const { updateServiceWorker } = useRegisterSW()
  await updateServiceWorker(true)
  window.location.reload()
}
